// 📄 types/transportConfirmation.ts
// Confirmación de pase de OT para un paso de un canal, en QAS o PRD. Vive
// anidado bajo el step de DEV (environments.DEV.channels.{canal}.step_{id}.
// transport.{QAS|PRD}) porque DEV es la única fuente de verdad de
// parámetros/OT/Personalización Z — QAS y PRD solo heredan esos valores en
// modo lectura y registran cuándo se transportó la OT hacia ellos.
export interface TransportConfirmation {
  transported: boolean;
  transportDate: string;
}

export const emptyTransportConfirmation = (): TransportConfirmation => ({
  transported: false,
  transportDate: ''
});
